import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { ModalService } from '@ui/modal/modal.service';
import { TwoFactorModalComponent } from '@features/user-settings/two-factor-modal/two-factor-modal.component';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom } from 'rxjs';

export const twoFactorGuard = async () => {
  const authService = inject(AuthService);
  const modalService = inject(ModalService);

  // Convert signal to observable and wait for non-null value
  await firstValueFrom(
    toObservable(authService.currentUser).pipe(
      filter(user => user !== null)
    )
  );

  // if (!authService.currentUser()?.two_factor_enabled) {
  //   modalService.open(TwoFactorModalComponent, {
  //     data: { isRequired: true },
  //   });
  //   return false;
  // }

  return true;
};
